import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, ConfigModule, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { translationOverwrites } from '../../../../../../public/asaleocare.translate'
import { UserPermissionsGuard } from '../../../../guards/user-permissions.guard'
import { AppConfigurationService } from '../../../../services/app-configuration.service'
import { SharedModule } from '../../../shared/shared.module'
import { NewCreditClaimModalModule } from '../new-credit-claim-modal/new-credit-claim-modal.module'
import { CreditClaimsHistoryComponent } from './credit-claims-history.component'

@NgModule({
  declarations: [CreditClaimsHistoryComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    SharedModule,
    SpinnerModule,
    NewCreditClaimModalModule,
    ConfigModule.withConfig({
      i18n: { resources: translationOverwrites }
    })
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        CreditClaimsHistoryComponent: {
          component: CreditClaimsHistoryComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig),
    AppConfigurationService
  ]
})
export class CreditClaimsHistoryModule {}
